import { useIntl } from "react-intl";

import Badge from "components/v2/Badge/Badge";
import SupportingText from "./SupportingText";

export default function Delivered() {
  const intl = useIntl();

  return (
    <SupportingText>
      {intl.formatMessage({
        id: "tracking.activity.changeStatusOfShipment",
        defaultMessage: "Changed the status of the shipment to",
      })}{" "}
      <Badge
        color="success"
        type="status-badge"
        variant="dot"
        label={intl.formatMessage({
          id: "tracking.Delivered",
          defaultMessage: "Delivered",
        })}
      />
    </SupportingText>
  );
}
